module.exports = __webpack_public_path__ + "static/img/216.1dd5d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/216.png
// module id = zUtW
// module chunks = 1